import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
    GET_ALL_PLAYERS,
    ASSIGN_COACH_TO_PLAYER,
    CHANGE_COACH_TO_PLAYER,
    REMOVE_COACH_TO_PLAYER
} from "../constants/ActionTypes";

import {
    getAllPlayersSuccess,
    getAllPlayersError,
    assignCoachToPlayerSuccess,
    assignCoachToPlayerError,
    changeCoachToPlayerSuccess,
    changeCoachToPlayerError,
    removeCoachToPlayerSuccess,
    removeCoachToPlayerError
} from "../actions/PlayerAction";
import { userSignOut } from '../actions/Auth'

import { getplayersWithPaginationApi, assignCoachToPlayerApi, changeCoachToPlayerApi, removeCoachToPlayerApi } from "../api/PlayerApi";

function* getAllPlayersData({ payload }) {//getplayersWithPaginationApi
    const { sessionToken } = payload
    try {
        // const players = yield call(getplayersApi, sessionToken);
        const players = yield call(getplayersWithPaginationApi, sessionToken, 10, 0);
        if (players.code) {
            if (players.code === 401) {
                yield put(userSignOut());
            } else {
                yield put(getAllPlayersError(players));
            }
        } else {
            yield put(getAllPlayersSuccess(players));
            if (players.length === 10) {
                yield call(getAllPlayersDataPagination, sessionToken, 50, players[players.length - 1].startDateTs);
            }
        }

    } catch (error) {
        yield put(getAllPlayersError(error));
    }
}
function* getAllPlayersDataPagination(sessionToken, limit, startDateTs) {
    try {
        // const players = yield call(getplayersApi, sessionToken);
        // var localLimit = limit;

        const players = yield call(getplayersWithPaginationApi, sessionToken, limit, startDateTs);
        if (players.code) {
            // yield put(getAllPlayersError(players));
            if (limit >= 50) {
                // localLimit = 25
                yield call(getAllPlayersDataPagination, sessionToken, 25, startDateTs);
            } else if (limit >= 25) {
                // localLimit = 10
                yield call(getAllPlayersDataPagination, sessionToken, 10, startDateTs);
            } else {
                yield put(getAllPlayersError(players));
            }
        } else {
            yield put(getAllPlayersSuccess(players));
            if (players.length === limit) {
                yield call(getAllPlayersDataPagination, sessionToken, limit, players[players.length - 1].startDateTs);
            }
        }
    } catch (error) {
        yield put(getAllPlayersError(error));
    }
}

function* assignCoachToPlayerRequest({ payload }) {
    try {
        const assignCoachResponse = yield call(assignCoachToPlayerApi, payload)
        if (assignCoachResponse.code) {
            yield put(assignCoachToPlayerError(assignCoachResponse));
        } else {
            yield put(assignCoachToPlayerSuccess(assignCoachResponse));
        }
    } catch (error) {
        yield put(assignCoachToPlayerError(error))
    }
}

function* changeCoachToPlayerRequest({ payload }) {
    try {
        const changeCoachResponse = yield call(changeCoachToPlayerApi, payload)
        if (changeCoachResponse.code) {
            yield put(changeCoachToPlayerError(changeCoachResponse));
        } else {
            yield put(changeCoachToPlayerSuccess(changeCoachResponse));
        }
    } catch (error) {
        yield put(changeCoachToPlayerError(error))
    }
}

function* removeCoachToPlayerRequest({ payload }) {
    try {
        const removeCoachResponse = yield call(removeCoachToPlayerApi, payload)
        if (removeCoachResponse.code) {
            yield put(removeCoachToPlayerError(removeCoachResponse));
        } else {
            yield put(removeCoachToPlayerSuccess(removeCoachResponse));
        }
    } catch (error) {
        yield put(removeCoachToPlayerError(error))
    }
}


export function* getPlayers() {
    yield takeEvery(GET_ALL_PLAYERS, getAllPlayersData);
}
export function* assignCoachToPlayer() {
    yield takeEvery(ASSIGN_COACH_TO_PLAYER, assignCoachToPlayerRequest);
}
export function* changeCoachToPlayer() {
    yield takeEvery(CHANGE_COACH_TO_PLAYER, changeCoachToPlayerRequest);
}
export function* removeCoachToPlayer() {
    yield takeEvery(REMOVE_COACH_TO_PLAYER, removeCoachToPlayerRequest);
}

export default function* rootSaga() {
    yield all([fork(getPlayers),
    fork(assignCoachToPlayer),
    fork(changeCoachToPlayer),
    fork(removeCoachToPlayer),
    ]);
}